export enum ScriptGameRoomStartMode {
  DelayedOnInsufficientPlayers = 1,
  Immediate = 2,
  Cancel = 3,
}

export enum ScriptGameRoomMode {
  ScoreRanking = 1,
}

export enum ScriptGameRoomStatus {
  Recruiting = 1,
  WaitingToStart = 2,
  InProgress = 3,
  Ended = 4,
  Canceled = 5,
}

export enum ScriptGameRoomPaymentMode {
  Host = 1,
  Split = 2,
}

export enum MateSpriteDirection {
  Up = 1,
  Down = 2,
  Left = 3,
  Right = 4,
}

export enum MateSpriteAction {
  Idle = 1,
  Running = 2,
}

export enum MateSpriteTaskMode {
  Frame = 1,
  Portrait = 2,
  Avatar = 3,
  PortraitAndAvatar = 4,
  Full = 5,
}
